// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../confluence/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../confluence/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
p,
div,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
dl,
img,
pre,
form,
fieldset {
	margin: 0;
	padding: 0;
}
img,
fieldset {
	border: 0;
}

body,
html {
	height: 100%;
	width: 100%;
}

body {
	background-color: var(--ds-surface, #fff);
	color: var(--ds-text, #172b4d);
	font: var(
		--ds-font-body,
		normal 400 14px/1.42857142857143 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	-ms-overflow-style: -ms-autohiding-scrollbar;
	text-decoration-skip-ink: auto;
}

/* Default margins */
p,
ul,
ol,
dl,
h1,
h2,
h3,
h4,
h5,
h6,
blockquote,
pre,
form,
table {
	margin: var(--ds-space-150, 12px) 0 0 0;
}

/* Links */
a {
	color: var(--ds-link, #0052cc);
	text-decoration: none;
}
a:hover {
	color: var(--ds-link, #0065ff);
	text-decoration: underline;
}
a:active {
	color: var(--ds-link-pressed, #0747a6);
}
a:focus-visible {
	outline: var(--ds-border-width-outline, 2px) solid var(--ds-border-focused, #2684ff);
	outline-offset: var(--ds-space-025, 2px);
}
@supports not selector(*:focus-visible) {
	a:focus {
		outline: var(--ds-border-width-outline, 2px) solid var(--ds-border-focused, #4c9aff);
		outline-offset: var(--ds-space-025, 2px);
	}
}
/* Headings */
h1 {
	font: var(
		--ds-font-heading-xlarge,
		600 2.0714285714285716em/1.103448275862069 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.01em;
	color: var(--ds-text);
	margin-top: var(--ds-space-500);
}
h2 {
	font: var(
		--ds-font-heading-large,
		500 1.7142857142857142em/1.1666666666666667 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.01em;
	color: var(--ds-text);
	margin-top: var(--ds-space-500);
}
h3 {
	font: var(
		--ds-font-heading-medium,
		500 1.4285714285714286em/1.2 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.008em;
	color: var(--ds-text);
	margin-top: 28px;
}
h4 {
	font: var(
		--ds-font-heading-small,
		600 1.1428571428571428em/1.25 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.006em;
	color: var(--ds-text);
	margin-top: var(--ds-space-300);
}
h5 {
	font: var(
		--ds-font-heading-xsmall,
		600 1em/1.1428571428571428 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.003em;
	color: var(--ds-text);
	margin-top: var(--ds-space-200);
}
h6 {
	font: var(
		--ds-font-heading-xxsmall,
		600 0.8571428571428571em/1.3333333333333333 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	color: var(--ds-text);
	margin-top: var(--ds-space-250);
	text-transform: uppercase;
}

/* Lists */
ul,
ol,
dl {
	padding-left: var(--ds-space-500, 40px);
}

dd,
dd + dt,
li + li {
	margin-top: var(--ds-space-050, 4px);
}
ul ul:not(:first-child),
ol ul:not(:first-child),
ul ol:not(:first-child),
ol ol:not(:first-child) {
	margin-top: var(--ds-space-050, 4px);
}

/* remove top margin for first element */
p:first-child,
ul:first-child,
ol:first-child,
dl:first-child,
h1:first-child,
h2:first-child,
h3:first-child,
h4:first-child,
h5:first-child,
h6:first-child,
blockquote:first-child,
pre:first-child,
form:first-child,
table:first-child {
	margin-top: 0;
}

/* Quotes */
blockquote,
q {
	color: inherit;
}
blockquote {
	border: none;
	padding-left: var(--ds-space-500, 40px);
}
[dir='rtl'] blockquote {
	padding-left: 0;
	padding-right: var(--ds-space-500, 40px);
}

blockquote::before,
q::before {
	content: '\\201C';
}

blockquote::after,
q::after {
	content: '\\201D';
}

blockquote::before {
	float: left;
	/* to keep the quotes left of any child elements like blockquote > p */
	margin-left: -1em;
	text-align: right;
	width: 1em;
}
[dir='rtl'] blockquote::before {
	float: right;
	margin-right: -1em;
	text-align: left;
}

blockquote > :last-child {
	display: inline-block; /* so the quotes added via pseudos follow it immediately. */
}

/* Other typographical elements */
small {
	font: var(
		--ds-font-body-small,
		normal 400 11px/16px ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	);
}

code,
kbd {
	font-family: var(
		--ds-font-family-code,
		ui-monospace,
		Menlo,
		'Segoe UI Mono',
		'Ubuntu Mono',
		monospace
	);
}

var,
address,
dfn,
cite {
	font-style: italic;
}

abbr {
	border-bottom: 1px var(--ds-border, #ccc) dotted;
	cursor: help;
}

@supports (color-scheme: dark) and (color-scheme: light) {
	[data-color-mode='light'] {
		color-scheme: light;
	}
	[data-color-mode='dark'] {
		color-scheme: dark;
	}
}

table {
	border-collapse: collapse;
	width: 100%;
}

thead,
tbody,
tfoot {
	border-bottom: 2px solid var(--ds-border, #dfe1e6);
}

td,
th {
	border: none;
	padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
	text-align: left;
}

th {
	vertical-align: top;
}

td:first-child,
th:first-child {
	padding-left: 0;
}

td:last-child,
th:last-child {
	padding-right: 0;
}

caption {
	font: var(
		--ds-font-heading-medium,
		500 1.4285714285714286em/1.2 -apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif
	);
	letter-spacing: -0.008em;
	color: var(--ds-text);
	margin-top: 28px;
	margin-bottom: var(--ds-space-100, 8px);
	text-align: left;
}

/* IE11 and some older browsers don't support these elements yet and treat them as display: inline; */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
	display: block;
}

/* Suppress the ugly broken image styling in Firefox */
@-moz-document url-prefix() {
	img {
		font-size: 0;
	}
	img:-moz-broken {
		font-size: inherit;
	}
}

/*
  Chrome 83.0.4103.61 introduced a new user-agent style that broke all buttons for us. This default override reverts it.
  chrome user agent added this => font: 400 13.3333px Arial;
*/
button {
	font-family: inherit;
}

.assistive {
	border: 0 !important;
	clip: rect(1px, 1px, 1px, 1px) !important;
	height: 1px !important;
	overflow: hidden !important;
	padding: 0 !important;
	position: absolute !important;
	width: 1px !important;
	white-space: nowrap !important;
}
`, "",{"version":3,"sources":["webpack://./../../../platform/packages/design-system/css-reset/src/bundle.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;CAiBC,SAAS;CACT,UAAU;AACX;AACA;;CAEC,SAAS;AACV;;AAEA;;CAEC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,yCAAyC;CACzC,8BAA8B;CAC9B;;;;;;;;;;;;EAYC;CACD,4CAA4C;CAC5C,8BAA8B;AAC/B;;AAEA,oBAAoB;AACpB;;;;;;;;;;;;;;CAcC,uCAAuC;AACxC;;AAEA,UAAU;AACV;CACC,8BAA8B;CAC9B,qBAAqB;AACtB;AACA;CACC,8BAA8B;CAC9B,0BAA0B;AAC3B;AACA;CACC,sCAAsC;AACvC;AACA;CACC,oFAAoF;CACpF,wCAAwC;AACzC;AACA;CACC;EACC,oFAAoF;EACpF,wCAAwC;CACzC;AACD;AACA,aAAa;AACb;CACC;;;;;;;;;;;;EAYC;CACD,uBAAuB;CACvB,qBAAqB;CACrB,+BAA+B;AAChC;AACA;CACC;;;;;;;;;;;;EAYC;CACD,uBAAuB;CACvB,qBAAqB;CACrB,+BAA+B;AAChC;AACA;CACC;;;;;;;;;;;;EAYC;CACD,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC;;;;;;;;;;;;EAYC;CACD,wBAAwB;CACxB,qBAAqB;CACrB,+BAA+B;AAChC;AACA;CACC;;;;;;;;;;;;EAYC;CACD,wBAAwB;CACxB,qBAAqB;CACrB,+BAA+B;AAChC;AACA;CACC;;;;;;;;;;;;EAYC;CACD,qBAAqB;CACrB,+BAA+B;CAC/B,yBAAyB;AAC1B;;AAEA,UAAU;AACV;;;CAGC,uCAAuC;AACxC;;AAEA;;;CAGC,oCAAoC;AACrC;AACA;;;;CAIC,oCAAoC;AACrC;;AAEA,wCAAwC;AACxC;;;;;;;;;;;;;;CAcC,aAAa;AACd;;AAEA,WAAW;AACX;;CAEC,cAAc;AACf;AACA;CACC,YAAY;CACZ,uCAAuC;AACxC;AACA;CACC,eAAe;CACf,wCAAwC;AACzC;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,sEAAsE;CACtE,iBAAiB;CACjB,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB,EAAE,2DAA2D;AACnF;;AAEA,iCAAiC;AACjC;CACC;;;;;;;;;;EAUC;AACF;;AAEA;;CAEC;;;;;;;EAOC;AACF;;AAEA;;;;CAIC,kBAAkB;AACnB;;AAEA;CACC,gDAAgD;CAChD,YAAY;AACb;;AAEA;CACC;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;;CAGC,kDAAkD;AACnD;;AAEA;;CAEC,YAAY;CACZ,0DAA0D;CAC1D,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC;;;;;;;;;;;;EAYC;CACD,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;CAChB,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA,qGAAqG;AACrG;;;;;;;;;;;;CAYC,cAAc;AACf;;AAEA,sDAAsD;AACtD;CACC;EACC,YAAY;CACb;CACA;EACC,kBAAkB;CACnB;AACD;;AAEA;;;CAGC;AACD;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,yCAAyC;CACzC,sBAAsB;CACtB,2BAA2B;CAC3B,qBAAqB;CACrB,6BAA6B;CAC7B,qBAAqB;CACrB,8BAA8B;AAC/B","sourcesContent":["html,\nbody,\np,\ndiv,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nul,\nol,\ndl,\nimg,\npre,\nform,\nfieldset {\n\tmargin: 0;\n\tpadding: 0;\n}\nimg,\nfieldset {\n\tborder: 0;\n}\n\nbody,\nhtml {\n\theight: 100%;\n\twidth: 100%;\n}\n\nbody {\n\tbackground-color: var(--ds-surface, #fff);\n\tcolor: var(--ds-text, #172b4d);\n\tfont: var(\n\t\t--ds-font-body,\n\t\tnormal 400 14px/1.42857142857143 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\t-ms-overflow-style: -ms-autohiding-scrollbar;\n\ttext-decoration-skip-ink: auto;\n}\n\n/* Default margins */\np,\nul,\nol,\ndl,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nblockquote,\npre,\nform,\ntable {\n\tmargin: var(--ds-space-150, 12px) 0 0 0;\n}\n\n/* Links */\na {\n\tcolor: var(--ds-link, #0052cc);\n\ttext-decoration: none;\n}\na:hover {\n\tcolor: var(--ds-link, #0065ff);\n\ttext-decoration: underline;\n}\na:active {\n\tcolor: var(--ds-link-pressed, #0747a6);\n}\na:focus-visible {\n\toutline: var(--ds-border-width-outline, 2px) solid var(--ds-border-focused, #2684ff);\n\toutline-offset: var(--ds-space-025, 2px);\n}\n@supports not selector(*:focus-visible) {\n\ta:focus {\n\t\toutline: var(--ds-border-width-outline, 2px) solid var(--ds-border-focused, #4c9aff);\n\t\toutline-offset: var(--ds-space-025, 2px);\n\t}\n}\n/* Headings */\nh1 {\n\tfont: var(\n\t\t--ds-font-heading-xlarge,\n\t\t600 2.0714285714285716em/1.103448275862069 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.01em;\n\tcolor: var(--ds-text);\n\tmargin-top: var(--ds-space-500);\n}\nh2 {\n\tfont: var(\n\t\t--ds-font-heading-large,\n\t\t500 1.7142857142857142em/1.1666666666666667 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.01em;\n\tcolor: var(--ds-text);\n\tmargin-top: var(--ds-space-500);\n}\nh3 {\n\tfont: var(\n\t\t--ds-font-heading-medium,\n\t\t500 1.4285714285714286em/1.2 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.008em;\n\tcolor: var(--ds-text);\n\tmargin-top: 28px;\n}\nh4 {\n\tfont: var(\n\t\t--ds-font-heading-small,\n\t\t600 1.1428571428571428em/1.25 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.006em;\n\tcolor: var(--ds-text);\n\tmargin-top: var(--ds-space-300);\n}\nh5 {\n\tfont: var(\n\t\t--ds-font-heading-xsmall,\n\t\t600 1em/1.1428571428571428 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.003em;\n\tcolor: var(--ds-text);\n\tmargin-top: var(--ds-space-200);\n}\nh6 {\n\tfont: var(\n\t\t--ds-font-heading-xxsmall,\n\t\t600 0.8571428571428571em/1.3333333333333333 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tcolor: var(--ds-text);\n\tmargin-top: var(--ds-space-250);\n\ttext-transform: uppercase;\n}\n\n/* Lists */\nul,\nol,\ndl {\n\tpadding-left: var(--ds-space-500, 40px);\n}\n\ndd,\ndd + dt,\nli + li {\n\tmargin-top: var(--ds-space-050, 4px);\n}\nul ul:not(:first-child),\nol ul:not(:first-child),\nul ol:not(:first-child),\nol ol:not(:first-child) {\n\tmargin-top: var(--ds-space-050, 4px);\n}\n\n/* remove top margin for first element */\np:first-child,\nul:first-child,\nol:first-child,\ndl:first-child,\nh1:first-child,\nh2:first-child,\nh3:first-child,\nh4:first-child,\nh5:first-child,\nh6:first-child,\nblockquote:first-child,\npre:first-child,\nform:first-child,\ntable:first-child {\n\tmargin-top: 0;\n}\n\n/* Quotes */\nblockquote,\nq {\n\tcolor: inherit;\n}\nblockquote {\n\tborder: none;\n\tpadding-left: var(--ds-space-500, 40px);\n}\n[dir='rtl'] blockquote {\n\tpadding-left: 0;\n\tpadding-right: var(--ds-space-500, 40px);\n}\n\nblockquote::before,\nq::before {\n\tcontent: '\\201C';\n}\n\nblockquote::after,\nq::after {\n\tcontent: '\\201D';\n}\n\nblockquote::before {\n\tfloat: left;\n\t/* to keep the quotes left of any child elements like blockquote > p */\n\tmargin-left: -1em;\n\ttext-align: right;\n\twidth: 1em;\n}\n[dir='rtl'] blockquote::before {\n\tfloat: right;\n\tmargin-right: -1em;\n\ttext-align: left;\n}\n\nblockquote > :last-child {\n\tdisplay: inline-block; /* so the quotes added via pseudos follow it immediately. */\n}\n\n/* Other typographical elements */\nsmall {\n\tfont: var(\n\t\t--ds-font-body-small,\n\t\tnormal 400 11px/16px ui-sans-serif,\n\t\t-apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\tUbuntu,\n\t\tsystem-ui,\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n}\n\ncode,\nkbd {\n\tfont-family: var(\n\t\t--ds-font-family-code,\n\t\tui-monospace,\n\t\tMenlo,\n\t\t'Segoe UI Mono',\n\t\t'Ubuntu Mono',\n\t\tmonospace\n\t);\n}\n\nvar,\naddress,\ndfn,\ncite {\n\tfont-style: italic;\n}\n\nabbr {\n\tborder-bottom: 1px var(--ds-border, #ccc) dotted;\n\tcursor: help;\n}\n\n@supports (color-scheme: dark) and (color-scheme: light) {\n\t[data-color-mode='light'] {\n\t\tcolor-scheme: light;\n\t}\n\t[data-color-mode='dark'] {\n\t\tcolor-scheme: dark;\n\t}\n}\n\ntable {\n\tborder-collapse: collapse;\n\twidth: 100%;\n}\n\nthead,\ntbody,\ntfoot {\n\tborder-bottom: 2px solid var(--ds-border, #dfe1e6);\n}\n\ntd,\nth {\n\tborder: none;\n\tpadding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);\n\ttext-align: left;\n}\n\nth {\n\tvertical-align: top;\n}\n\ntd:first-child,\nth:first-child {\n\tpadding-left: 0;\n}\n\ntd:last-child,\nth:last-child {\n\tpadding-right: 0;\n}\n\ncaption {\n\tfont: var(\n\t\t--ds-font-heading-medium,\n\t\t500 1.4285714285714286em/1.2 -apple-system,\n\t\tBlinkMacSystemFont,\n\t\t'Segoe UI',\n\t\t'Roboto',\n\t\t'Oxygen',\n\t\t'Ubuntu',\n\t\t'Fira Sans',\n\t\t'Droid Sans',\n\t\t'Helvetica Neue',\n\t\tsans-serif\n\t);\n\tletter-spacing: -0.008em;\n\tcolor: var(--ds-text);\n\tmargin-top: 28px;\n\tmargin-bottom: var(--ds-space-100, 8px);\n\ttext-align: left;\n}\n\n/* IE11 and some older browsers don't support these elements yet and treat them as display: inline; */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection {\n\tdisplay: block;\n}\n\n/* Suppress the ugly broken image styling in Firefox */\n@-moz-document url-prefix() {\n\timg {\n\t\tfont-size: 0;\n\t}\n\timg:-moz-broken {\n\t\tfont-size: inherit;\n\t}\n}\n\n/*\n  Chrome 83.0.4103.61 introduced a new user-agent style that broke all buttons for us. This default override reverts it.\n  chrome user agent added this => font: 400 13.3333px Arial;\n*/\nbutton {\n\tfont-family: inherit;\n}\n\n.assistive {\n\tborder: 0 !important;\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\toverflow: hidden !important;\n\tpadding: 0 !important;\n\tposition: absolute !important;\n\twidth: 1px !important;\n\twhite-space: nowrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
